const letterToNumber = {
  a: 1,
  b: 2,
  c: 3,
  d: 4,
  e: 5,
  f: 6,
  g: 7,
  h: 8,
  i: 9,
  j: 10,
  k: 11,
  l: 12,
  m: 13,
  n: 14,
  o: 15,
  p: 16,
  q: 17,
  r: 18,
  s: 19,
  t: 20,
  u: 21,
  v: 22,
  w: 23,
  x: 24,
  y: 25,
  z: 26,
};

export function xlsToItems(
  rows: Array<Array<string | number | null>>,
  columns: {
    name: string;
    description: string;
    price: string;
    category: string;
  },
  startRow = 1
) {
  const letraANroColumna = (letra: string) => {
    return letterToNumber[letra.toLowerCase()] - 1;
  };

  const items = [];

  for (let index = 0; index < rows.length; index++) {
    if (startRow > index) continue;

    const name = rows[index][letraANroColumna(columns.name)];

    if (name === null) continue;

    items.push({
      name, // = a name: name
      description: rows[index][letraANroColumna(columns.description)],
      price: rows[index][letraANroColumna(columns.price)],
      category: rows[index][letraANroColumna(columns.category)],
    });
  }

  return items;
}
